import { shouldUseLocal, extractLocalMFs } from '../localDev/index.js';

function getMFDataFromAssetsDir(mfAssetsDir) {
    const tokens = mfAssetsDir.split('/');
    const version = tokens[tokens.length - 1];
    const name = tokens[tokens.length - 2];
    return { name, version };
}
function overrideAssetsVersionIfNeeded({ mfName, assetsDir, manifestPath, }) {
    if (!shouldUseLocal(mfName)) {
        return { assetsDir, manifestPath };
    }
    const localMfsConfig = extractLocalMFs();
    const { endpoint, version } = localMfsConfig[mfName] || {};
    if (endpoint) {
        return { assetsDir: endpoint, manifestPath: `${endpoint}/asset-manifest.json` };
    }
    if (version) {
        if (manifestPath) {
            // overriding the version of asset-manifest
            // i.e "https://microfrontends.monday.com/Docs/latest/asset-manifest.10.json" =>
            // ['https://microfrontends.monday.com/Docs/latest/', '.192.json'] =>
            // "https://microfrontends.monday.com/Docs/latest/asset-manifest.20.json"
            const splitted = manifestPath.split('asset-manifest');
            return { assetsDir, manifestPath: `${splitted[0]}asset-manifest.${version}.json` };
        }
        // overriding the version with specific one
        // i.e. "https://microfrontends.monday.com/Docs/10" => "https://microfrontends.monday.com/Docs/20"
        const index = assetsDir.lastIndexOf('/');
        const assetsDirRes = `${assetsDir.substring(0, index + 1)}${version}`;
        return { assetsDir: assetsDirRes, manifestPath: `${assetsDirRes}/asset-manifest.json` };
    }
    return { assetsDir, manifestPath };
}

export { getMFDataFromAssetsDir, overrideAssetsVersionIfNeeded };
